module.exports = __webpack_public_path__ + "img/45.10e6533b.png";